module.exports = __webpack_public_path__ + "static/media/satafrika.522a2a68.svg";